/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBarContainer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-2 2H4v16h16zm-5 2v12H9V6zM7 6v12H5V6zm12 0v12h-2V6zm-6 2h-2v8h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBarContainer as BarContainer };
